const config = {
    apiUrl: 'https://portal-api.server-dragracesuperstar.com',
};
export default config;
